<template>
  <div>
    <b-button v-if="isMobile" id="addButton" variant="none">
      <img src="../../assets/img/icon/mobile-add.svg" alt="add" />
    </b-button>
    <b-button v-else id="addButton" variant="primary">
      <b-icon-plus scale="1.6" /> 新增最新消息
    </b-button>
    <b-popover target="addButton" triggers="click blur" placement="bottom">
      <div style="padding: 0; display: flex; flex-direction: column">
        <div class="popover__header">
          選擇消息類型
        </div>
        <div class="popover__option" @click="$router.push({ name: 'AddBlogNotification' })">
          Blog post
        </div>
        <div class="popover__option" @click="$router.push({ name: 'AddEdmNotification' })">
          EDM
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
import buttonMixin from '@/mixins/button';
import isMobileMixin from '@/mixins/is-mobile';
import { BButton, BIconPlus, BPopover } from 'bootstrap-vue';

export default {
  mixins: [buttonMixin, isMobileMixin],
  components: {
    BButton,
    BIconPlus,
    BPopover,
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .popover-body {
    padding: 0;
  }
}

.popover {
  $padding: 0.75rem 1.25rem;

  &__header {
    padding: $padding;
    border-bottom: 1px solid #00000033;
    color: #00000088;
    user-select: none;
  }

  &__option {
    padding: $padding;
    cursor: pointer;
  }
}
</style>
